import React from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Grid } from 'semantic-ui-react';
import Control from './control';
import './style.css';
import ReadCookie from '../../functions/readcookies';
import Permission from '../../functions/permission';

class Executivebranch extends React.Component {

  state = {
    load: false, message: '', menuPermission: [],
    executiveBranch: [], allbranch: []
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let url = "executive-web-branch-mapping";
    if(this.props.from == "ModeControl") {
      url = "web-payment-mode-mapping";
    }
    if(this.props.from == "AppControl") {
      url = "executive-app-branch-mapping";
    }
    if(this.props.from == "AppModeControl") {
      url = "app-payment-mode-mapping";
    }
    let menuPermission = Permission(url, this.props.menus);
    if (menuPermission.view) {
      this.setExecutiveBranch();
      this.getBranchs();
    }
    this.setState({ menuPermission })
  }

  getBranchs() {
    let context = this;
    context.setState({ load: true, message: 'Getting Branchs' })
    let url = Server() + 'branchdetails/getallbranchs.php';
    if (this.props.from == 'ModeControl' || this.props.from == 'AppModeControl') {
      url = Server() + 'addmenu/mode/getmode.php';
    }
    $.ajax({
      type: 'POST', url: url,
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ load: false, allbranch: data });
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  setExecutiveBranch() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({ load: true, message: 'Getting Executive!!!' });
    let url = Server() + 'executivebranch/get.php';
    if (context.props.from == 'AppControl') {
      url = Server() + 'executiveappbranch/get.php';
    }
    else if (context.props.from == 'ModeControl') {
      url = Server() + 'addmenu/mode/getmodecontrol.php';
    }
    else if (context.props.from == 'AppModeControl') {
      url = Server() + 'executiveappmodecontrol/getmodecontrol.php';
    }
    else if (context.props.from == 'TransferControl') {
      url = Server() + 'transfercontrol/getcontrol.php';
    }
    $.ajax({
      type: 'POST', data: { 'userId': userId }, url: url,
      success: function(data) {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1; data[i].sino = s + i;
          }
          context.setState({ executiveBranch: data })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let title = "Executive Branch Mapping";
    let tableheadername = "Branch";
    if (this.props.from == 'AppControl') {
      title = "Executive Branch Mapping";
      tableheadername = "Branch";
    }
    else if (this.props.from == 'ModeControl') {
      title = "Payment Mode Control";
      tableheadername = "Payment Mode";
    }
    else if (this.props.from == 'AppModeControl') {
      title = "Payment Mode Control";
      tableheadername = "Payment Mode";
    }
    else if (this.props.from == 'TransferControl') {
      title = "Transfer Control";
      tableheadername = "Modes";
    }
    return (
      <div>
        <Title title={title} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <Grid style={{display: this.state.executivebranchview}}>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                { this.state.allbranch.length > 0 ?
                  (
                    <div style={{padding: '0.5%', height: '89vh'}} id="scrollsss">
                      <table width="100%" id="table">
                        <tr>
                          <th id='tableheader' style={{ width: '7%' }}>Sino<center></center></th>
                          <th id='tableheader' style={{ width: '30%' }}>Executive<center></center></th>
                          <th id='tableheader' style={{ width: '63%' }}>{tableheadername}<center></center></th>
                        </tr>
                        { this.state.executiveBranch.map((z) => {
                            let y = [];
                            let id = z.id;
                            if (z.type == 'executive') {
                              return (
                                <tr>
                                  <td><center>{z.sino}</center></td>
                                  <td>{z.name}</td>
                                  <td>
                                    <center>
                                      { this.state.executiveBranch.map((x) => {
                                          if (x.type == 'branch' && z.id == x.emp_id) {
                                            y.push(x.name);
                                          }
                                        })
                                      }
                                      <Control menuPermission={this.state.menuPermission} from={this.props.from} executivebranchedit={this.state.executivebranchedit} data={y} id={id} allbranch={this.state.allbranch}  />
                                    </center>
                                  </td>
                                </tr>
                              )
                            }
                          })
                        }
                      </table>
                    </div>
                  ) : (<div></div>)
                }
                </Grid.Column>
              </Grid>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Executivebranch;
